import React from "react"
import "./arrows.scss";

export function PrevArrow() {

    return (
        <svg
            className="prev-arrow"
            height={56}
            width={56}
            viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={28} cy={28} r={28} transform="matrix(-1 0 0 1 56 0)" fill="#FED966" />
            <path d="M31 32L26.3137 28" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M31 24L26.3137 28" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export function NextArrow() {

    return (
        <svg
            width={56}
            height={56}
            className="next-arrow"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={28} cy={28} r={28} fill="#FED966"/>
            <path d="M26 32L30.6863 28" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M26 24L30.6863 28" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}